var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrxUpdateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 3,
    fill: "#E5602F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6 18.52H8M8 18.52C8 18.52 11 23 15.5 23C19.6424 23 23 19.8 23 15.96M8 18.52V23M19.4 11.48H23M23 11.48C23 11.48 20 7 15.5 7C11.3576 7 8 10.2 8 14.04M23 11.48V7",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrxUpdateIcon);
export default __webpack_public_path__ + "static/media/trx-update-icon.77a28028681a32e4c1284507749d82bf.svg";
export { ForwardRef as ReactComponent };